module.exports = __webpack_public_path__ + "static/media/post02.52af0536.jpg";